import React from "react";
import { connect } from "react-redux";
import { getEnquiryIntrestedProduct } from "../../../Slice/enquiryOperations.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { EnquiryInterestedProductColumns } from "../../../tableColumns/table-columns";
import { EnquiryIntrestedProductJson } from "../../../DynamicFormsJson/MastersJSON/enquiryIntrestedProduct";

class EnquiryIntrestedProductTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { enquiryIntrestedProduct, getEnquiryIntrestedProduct } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={EnquiryIntrestedProductJson.formPath}
                    screenTitle={EnquiryIntrestedProductJson.screenTitle}
                    fieldMeta={EnquiryIntrestedProductJson.fieldMeta}
                    showPdfDownload={EnquiryIntrestedProductJson.showPdfDownload}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={EnquiryIntrestedProductJson.pdfFileName}
                    excelFileName={EnquiryIntrestedProductJson.excelFileName}
                    showAddButton={EnquiryIntrestedProductJson.showAddButton}
                    tableColumnsToFilter={EnquiryIntrestedProductJson.tableColumnsToFilter}
                    tableColumns={EnquiryInterestedProductColumns}
                    tableData={enquiryIntrestedProduct?.enquiryIntrestedProduct}
                    getTableData={getEnquiryIntrestedProduct}
                    apiBaseURL={EnquiryIntrestedProductJson.apiBaseURL}
                    baseIdColumn={EnquiryIntrestedProductJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={EnquiryIntrestedProductJson.noteValue}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    isActiveURL={EnquiryIntrestedProductJson.isActiveURL}
                    isActiveURLGET={true}
                    showView={false}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    enquiryIntrestedProduct: state.enquiryOperations,
});

const mapDispatchToProps = {
    getEnquiryIntrestedProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryIntrestedProductTable);